// extracted by mini-css-extract-plugin
export default {"FancyRenderEngine":"FancyRenderEngine_FancyRenderEngine__Lg4n5","dragContainer":"FancyRenderEngine_dragContainer__5yJl+"};